import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
  return {
    primary: {
      backgroundColor: theme.colors["neutral.900"],
      borderRadius: "8px",
      '& .MuiAutocomplete-clearIndicator :hover': {
        color: theme.colors["neutral.50"]
      },
      '& .MuiAutocomplete-clearIndicator': {
        color: theme.colors["neutral.50"]
      }
    },
    secondary: {
      backgroundColor: theme.colors["neutral.950"],
      borderRadius: "8px",
      '& .MuiAutocomplete-clearIndicator :hover': {
        color: theme.colors["neutral.50"]
      },
      '& .MuiAutocomplete-clearIndicator': {
        color: theme.colors["neutral.50"]
      }
    }
  }
}

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
      fontSize: theme.fontSizes.sm,
      '& .MuiInputBase-input': {
        padding: `${theme.space._200} ${theme.space._300} ${theme.space._200} ${theme.space._300}`,
        fontSize: theme.fontSizes.sm
      },
      '& .MuiAutocomplete-inputRoot': {
        paddingTop: "0.5px",
        paddingBottom: "0.5px"
      }
    },
    md: {
      fontSize: theme.fontSizes.md,
      '& .MuiInputBase-input': {
        padding: `${theme.space._300}`,
      }
    },
    lg: {
      fontSize: theme.fontSizes.lg,
      '& .MuiInputBase-input': {
        padding: `${theme.space._400} ${theme.space._300} ${theme.space._400} ${theme.space._300}`,
      }
    },
  };
};